import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";

import Advanced_Card_Shuffling from "../../../assets/Services/Rummy_Game/Features_We_Provide/Advanced_Card_Shuffling.svg";
import Event_Integration from "../../../assets/Services/Rummy_Game/Features_We_Provide/Event_Integration.svg";
import Multiplatform from "../../../assets/Services/Rummy_Game/Features_We_Provide/Multi-Platform_Vacuity.svg";
import Personality_ from "../../../assets/Services/Rummy_Game/Features_We_Provide/Personality_&_fidelity.svg";
import Multiple_Game from "../../../assets/Services/Rummy_Game/Features_We_Provide/Multiple_Game.svg";

import Demand_Analysis from "../../../assets/Services/Rummy_Game/Our_Development_process/Demand_Analysis.svg";
import Deployment_ from "../../../assets/Services/Rummy_Game/Our_Development_process/Deployment_&_Ongoing.svg";
import Design_ from "../../../assets/Services/Rummy_Game/Our_Development_process/Design_&_Stoner.svg";
import Development from "../../../assets/Services/Rummy_Game/Our_Development_process/Development-&_System.svg";
import Testing_ from "../../../assets/Services/Rummy_Game/Our_Development_process/Testing_&_Quality.svg";

import Maskgroup from "../../../assets/Services/Rummy_Game/Voice_of_success/Maskgroup(1).png";
import Maskgroup2 from "../../../assets/Services/Rummy_Game/Voice_of_success/Mask group4.png";
import Maskgroup3 from "../../../assets/Services/Rummy_Game/Voice_of_success/Maskgroup.png";

import Driven_Player from "../../../assets/Services/Rummy_Game/Why_Choose_Raiden_Labs/AI-Driven_Player.svg";
import Comprehensive_Security from "../../../assets/Services/Rummy_Game/Why_Choose_Raiden_Labs/Comprehensive_Security.svg";
import Comprehensive_Security_ from "../../../assets/Services/Rummy_Game/Why_Choose_Raiden_Labs/Comprehensive_Security_(1).svg";
import Rearmost_Technology from "../../../assets/Services/Rummy_Game/Why_Choose_Raiden_Labs/Rearmost_Technology.svg";
import Scalable_Gaming from "../../../assets/Services/Rummy_Game/Why_Choose_Raiden_Labs/Scalable_Gaming.svg";

import Arcade_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png";
import Bingo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png";
import Board_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png";
import Ludo_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png";
import Rummy_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png";
import Poker_Game_Development from "../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png";
import Unreal_Engine_Development from "../../../assets/Services/Arcade_dev/Unreal_Engine_Development.png";


import AI_powered from '../../../assets/Services/Rummy_Game/Our_End-to-EndRummy/AI-powered.png'
import Custom_rummy from '../../../assets/Services/Rummy_Game/Our_End-to-EndRummy/Custom_rummy.png'
import Launch_support from '../../../assets/Services/Rummy_Game/Our_End-to-EndRummy/Launch_support.png'
import Real_time_multi from '../../../assets/Services/Rummy_Game/Our_End-to-EndRummy/Real_time_multi.png'
import Secure_payment from '../../../assets/Services/Rummy_Game/Our_End-to-EndRummy/Secure_payment.png'

import big from '../../../assets/Services/Game_page/rummy/big.svg'
import icon from '../../../assets/Services/Game_page/rummy/icon_(2).svg'
import icon2 from '../../../assets/Services/Game_page/rummy/iocn_1.svg'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";
const RummyGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Custom Rummy Game Development  ",
      desc: "Our professed designers develop interactive and intuitive tech game interfaces with customizable themes, table designs, and robust visual cards. We prioritize user experience optimization to give flawless navigation, responsive controls, and engaging gameplay across all biases and software .",
      img:Custom_rummy ,
    },
    {
      title: " Real-Time Multiplayer & Tournament Systems  ",
      desc: "produce sophisticated tech platforms supporting real-time multiplayer gameplay with instant matchmaking. Our results enable 2- 6 players to contend simultaneously  across multiple tables with professional event operation, type systems, and automated prize distribution.   ",
      img: Real_time_multi,
    },
    {
      title: " Secure Payment & Cash Gaming Integration    ",
      desc: " Establish robust payment systems supporting conventional banking styles and digital deals. Our PCI DSS Level 1 biddable results ensure secure deposits and withdrawals  with multi-layered fraud protection, instant cash-escrow processing, and comprehensive sale monitoring.  ",
      img: Secure_payment,
    },
    {
      title: "  AI-Powered Player Analytics ",
      desc: " Use machine learning algorithms to dissect player gestures, optimize game performance, and apply responsible gaming measures. Our AI systems give substantiated tournament recommendations, detect conspiracy patterns, and enhance player retention through data-driven insights and skill assessment.  ",
      img: AI_powered,
    },
    // {
    //   title: " Regulatory Compliance & Licensing  ",
    //   desc: "Navigate complex skill-gaming regulations across multiple authorities, including India, USA, Europe, and arising requests. Our compliance experts ensure your rummy platform meets all legal conditions, GST compliance, TDS operation, and responsible gaming protocols.   ",
    //   img:  ,
    // },
    // {
    //   title: " Blockchain & Transparent Gaming  ",
    //   desc: "Implement blockchain technology for provably fair card shuffling, transparent game results, and secure sale processing. Smart contract integration enables automated prize distribution, empirical game issues, and decentralized event operation for enhanced player trust.   ",
    //   img: blockchain,
    // },
    // {
    //   title: "Social Features & Community Structure   ",
    //   desc: " produce engaging social gaming features, including friend systems, conversation functionality, clubs, and private table hosting. Players can produce custom games, share in community challenges, and make social networks that drive long-term engagement and retention.  ",
    //   img:socia ,
    // },

    {
      title: " Launch Support & Ongoing maintenance   ",
      desc: "    Comprehensive specialized support, including regular security updates, new game variants, bug resolution, and platform optimization. Our devoted maintenance platoon ensures 24/7 uptime, garçon monitoring, and rapid-fire response to specialized issues or regulatory changes. ",
      img: Launch_support,
    },
  ];

  const pokerdevcompany2 = [
    {
      title: " Rearmost Technology Integration  ",
      icon:Rearmost_Technology,
      desc: "   We influence slice-edge technologies including AI, blockchain, real-money gaming integration, and advanced plate machines to develop coming-generation rummy gaming gests. Our specialized moxie spans Unity 3D, fantastic Machine, React Native, Node.js, smart contracts, and enterprise platform structure.  ",
    },
    {
      title: " Comprehensive Security & Regulatory Compliance  ",
      icon:Comprehensive_Security,
      desc: "  Raiden Labs tools bank- grade security protocols, certified card shuffling systems, and advanced anti-fraud measures to ensure fully fair and secure gaming. Our security frame includes SSL encryption, PCI DSS  Level 1 compliance, multi-factor authentication, real-time sale monitoring, and comprehensive inspection trails.  ",
    },
    {
      title: " Global Regulatory Expertise  ",
      icon:Comprehensive_Security_,
      desc: "Our platoon possesses extensive experience with skill-gaming regulations across India, the USA, Europe, Asia, and emerging countries. We ensure your rummy platform complies with original gaming laws, duty regulations, licensing conditions, and responsible gaming authorizations for successful transnational launches.    ",
    },
    {
      title: " Scalable Gaming Structure  ",
      icon:Scalable_Gaming,
      desc: "   We specialize in developing high-performance tech platforms able to handle millions of concurrent players with zero time-out. Our enterprise-grade armature provides lightning-fast game loading, real-time multiplayer functionality, instant payment processing, and flawless cross-platform synchronization.  ",
    },
    {
      title: "  AI-Driven Player Intelligence ",
      icon:Driven_Player,
      desc: " Our artificial intelligence results enhance player engagement through substantiated event recommendations, dynamic perk offers, skill-grounded matchmaking, and responsible gaming monitoring.     ",
    },
  ];

  const pokerdevcompany = [
    {
      title: "   Demand Analysis & Compliance Planning  ",
      icon: Demand_Analysis,
      desc: "We begin by understanding customer objects, assessing target requests, and defining regulatory conditions. Our specialists ensure your rummy platform aligns with brand identity, player demographics, empowering authorities, and incorporates essential features like certified RNG and responsible gaming tools.     ",
    },
    {
      title: " Design & Stoner Experience Prototyping   ",
      icon: Design_,
      desc: " Our designers create wireframes with the best UI designs. We develop responsive designs optimized for multiple biases, ensuring consistent interactions across mobile, tablet, and desktop platforms with engaging card mechanics and decoration visual aesthetics.    ",
    },
    {
      title: " Development & System Integration    ",
      icon: Development,
      desc: "  Our development platoon utilizes state- of- the- art technologies to deliver comprehensive alcoholic gaming results. We apply advanced features including real-time multiplayer tables, secure payment gateways, event operation systems, social functionality, and high-definition card plates for superior gaming guests.   ",
    },
    {
      title: " Testing & Quality Assurance    ",
      icon: Testing_,
      desc: "  Rigorous testing protocols ensure impeccable performance across all gaming scripts. We conduct functional testing, security checkups, RNG instrument, compliance verification, and cargo testing to guarantee smooth gameplay, fair card distribution, and secure sale processing.   ",
    },
    {
      title: "  Deployment & Ongoing Support  ",
      icon: Deployment_,
      desc: "Following successful testing, we will implement your rummy platform across target requests and give comprehensive consultation support. Our support platoon delivers regular security updates, new game variants, regulatory compliance monitoring, and performance optimization to maintain competitive advantage.     ",
    },
  ];

  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon: Arcade_Game_Development,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon: Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Bingo Game Development",
      icon: Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon: Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon: Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: "Unreal Engine Development",
      icon: Unreal_Engine_Development,
      desc: " Our mastery of Unreal Engine enables us to produce games with excellent performance and fidelity. Our pipeline offers realistic rendering, advanced physics, and scalable multiplayer architectures, and it works with both PC and console platforms.",
      link: "/unreal-engine-game-development",
    },
  ];

  const custom = [
    {
      icon: Multiple_Game,
      title: " Multiple Game modes   ",
      desc: " We create various rummy games that have different modes. Each mode has different rules, entry freights, and prize structures designed for colorful player skill situations and preferences, keeping players continuously engaged.   ",
    },
    {
      icon: Event_Integration,
      title: "  Event Integration  ",
      desc: " We produce comprehensive event systems with  daily, and special event competitions. Multi-table events with elimination rounds, satellite qualifiers, and crown series featuring substantial prize pools and leaderboard rankings.  ",
    },
    {
      icon: Advanced_Card_Shuffling,
      title: "Advanced Card Shuffling Systems    ",
      desc: " Certified Random Card Distribution ensures fair play across all games. Third-party audited algorithms guarantee changeable card sequences and maintain player confidence through transparent shuffling mechanics and anti-collusion measures.  ",
    },
    {
      icon: Personality_,
      title: "Personality & Loyalty Programs   ",
      desc: " Multi-tier price systems with exclusive bonuses, rakeback offers, and personalized account operation. Progressive fidelity point system with real-world prices, decoration table access, and personality event assignments.  ",
    },
    {
      icon: Multiplatform,
      title: "Multi-Platform Availability",
      desc: "  flawless gaming across desktop, mobile, and tablet platforms with accompanying accounts and game progress. Native iOS and Android operations with web-grounded performances for universal cross-platform availability.  ",
    },
  ];

  const clientexp = [
    {
      icon: Maskgroup,
      name: "Lussy",

      desc: "Raiden Labs converted our vision into a world-class alcoholic platform that exceeds assiduity norms. Their genuine inventors invested time understanding our unique request conditions and delivered a customized result that surpassed our expectations. From original discussion through platform launch, every phase was executed faultlessly. Working with an established alcoholic development mate who truly understands the skill-gaming industry has been inestimable. I  largely recommend Raiden Labs for all rummy game development  requirements!",
    },
    {
      icon: Maskgroup2,
      name: "Olivia Rodriguez",
      undername: " ",
      desc: "The professionalism and moxie demonstrated by Raiden Labs were apparent from our first meeting. As a company seeking a robust gaming result, we demanded inventors who could navigate the complications of skill-gaming regulations and specialized integration. With their 15 years of experience, they provided strategic guidance and eased our successful request entry. Our platform delivers exceptional gaming experiences, and our players enjoy flawless, secure gameplay. Choosing Raiden Labs as our alcoholic development  mate was our stylish business decision.",
    },
    {
      icon: Maskgroup3,
      name: "  Cyril",
      undername: "  ",
      desc: " I'm completely impressed with Raiden Labs! Their rummy game development services converted our outdated platform into an ultramodern, immersive gaming destination.. Our games have become more engaging, and our players get a hassle-free experience. Opting for Raiden Labs as our rummy game development company was one of the best decisions we ever made",
    },
  ];
  const handleClick=(e)=>{
    
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   
  
   .catch((error)=>console.log("error in the api",error))
  
  }


  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              Rummy Game Development Company
            </h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs is a leading Rummy Game Development company that
              provides secure and scalable Rummy Gaming results. We develop
              engaging, high-performance tech games with  cutting-edge technologies
              to ensure maximum player engagement and profit generation.{" "}
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
        <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={big} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Our Rummy Game Development results
            </h2>
            <p className="mt-4  h1-para" >
              Raiden Labs is at the forefront of the Rummy Game Development
              sector, combining AI, blockchain, and  real-money gaming
              technology to deliver thrilling gaming experiences on web, mobile,
              PC, and press platforms. With a keen focus on advanced mechanics
              and responsible gaming practices, we're reconsidering industry
              norms. We Develop Innovative Features
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Multi-currency support for transnational requests
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Skill- grounded gaming with certified fair play algorithms
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Responsible gaming tools and player protection features
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our End-to-End Rummy Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          Raiden Labs prides itself on utilizing the latest tools and frameworks
          to ensure our games are not only beautiful and fun but also stable,
          secure, and future-proof.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Features We Provide in Rummy Game
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            Our Rummy game service includes the best features that are crucial
            for rummy game development. It provides security measures to help
            you with payment gateways
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row justify-content-center align-items-center ">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                What We Offer
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Unite with us for bespoke alcoholic software designed for
                security, compliance, scalability, and exceptional player
                experience in the competitive skill-gaming market
              </p>
              <Link to="/request-quote">
                <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                  TALK WITH OUR EXPERTS NOW!
                </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon2} alt="" className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            The Raiden Edge: Advanced Tech and a Flawless Rummy
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge VR gameplay  experience.
          </p>
          <CoreComponent32 />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal Unity: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
              Raiden Labs platform's real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your Unity app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37 />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row align-items-center   flex-column-reverse  flex-lg-row justify-content-center "> 
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Secure Your Digital World
              </h2>
              <p
                className="h1-para text-white  lh-base"
                style={{ opacity: 0.6 }}
              >
                Protect your business from threats. Our security specialists
                provide robust solutions to safeguard your data and fortify your
                infrastructure, giving you peace of mind.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon} alt=""  className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Why Choose Raiden Labs for Rummy Game Development
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Our process focuses on transforming an initial concept into a finished
          product, building a compelling world and story while engineering the
          underlying technology, and finalizing the experience with
          comprehensive audio and a strategic launch plan.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 ">
        <h2 className="text-center lh-base h2-heading ">
          Our Development Process
        </h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          We are able to translate complicated concepts into dependable, useful
          frameworks for understanding technical and  industry-specific demands.
          Our comprehensive understanding benefits customers by ensuring
          reliable and effective solutions.{" "}
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 ">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Hear directly from those who've partnered with us. These testimonials
          reflect Raiden Labs' commitment to excellence, innovation, and client
          satisfaction in Unreal Engine game creation.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RummyGameDev;
